import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import UsersAutocomplete from '../../../shared/users-autocomplete';
import AvatarChip from '../../../shared/avatar-chip';
import Box from '@mui/material/Box';

export function ActorFilter(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const [autoCompleteValue, setAutoCompleteValue] = useState<string>('');

  const handleFilterChange = (newValue: string) => {
    setAutoCompleteValue(newValue);
    applyValue({ ...item, value: newValue });
  };

  return (
    <Box
      sx={{
        width: 300,
        position: 'relative',
        top: item.value ? 0 : -19.5,
        left: item.value ? 4 : 0,
      }}
    >
      {item.value ? (
        <AvatarChip
          type="User"
          email={item.value}
          onDelete={() => {
            setAutoCompleteValue('');
            applyValue({ ...item, value: '' });
          }}
        />
      ) : (
        <UsersAutocomplete
          autocompleteValue={autoCompleteValue}
          setAutoCompleteValue={handleFilterChange}
          variant="standard"
        />
      )}
    </Box>
  );
}
